<div class="surface-0 flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
    <div class="grid justify-content-center p-2 lg:p-0" style="min-width: 80%;">
        <div class="col-12 mt-5 xl:mt-0 text-center">
            <img src="assets/img/logo.png" class="mb-5 mt-4" style="border-radius: 5px;" />
        </div>
        <div class="col-12 xl:col-6" style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, black 10%, rgba(33, 150, 243, 0) 30%);">
            <div class="h-full w-full m-0 py-7 px-4" style="border-radius: 53px; background: linear-gradient(180deg, var(--surface-50) 38.9%, var(--surface-0));">
                <div class="text-center mb-5">
                    <div class="text-900 text-3xl font-medium mb-3" style="font-family: Albert Sans Regular;">
                        Textos Legales
                    </div>
                    <div class="text-600 font-medium" style="font-family: Albert Sans Regular;text-align:justify;">
                        
					</div>
                </div>
                <div class="w-full md:w-10 mx-auto">
                    <div *ngIf="loading" class="text-center">
                        <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
